<script>
  import ModalMessage from "../HTMLElements/ModalMessage.svelte";
  import ModalConfirm from "../HTMLElements/ModalConfirm.svelte";
  import Spinner from "../HTMLElements/Spinner.svelte";
  import Help from "../help.svelte";
  import Modal from "../HTMLElements/Modal.svelte";
  import {createEventDispatcher,onMount} from 'svelte';
  import { Child } from "./store.js";
  import wrappedFetch from '../../wrappedfetch.js';
  import * as utils from "../Utils/utils.js";
  const dispatch = new createEventDispatcher();
  export let id;
  export let applicationId;
  let showMessage = false;
  let modalMessage;

  let showAddFile = false;
  let showAddFile_v2 = false;

  let docPreview;
  let docName;
  let documents = [];
  let fileToDelete;
  let showTest = false;
  let showHelpModal = false;
  let helpId = "Help37";
  let docType;
  let uploadError = "";
  let document;
  let documentText = '';
  
  let documentTypeID;
  let documentTypeName;
  let documentTypeParentName;

  let uploadingDocument = false;
  let isDocTypeValid = false;
  let isDocTypeDirty = false;
  let docTypeError = "";
  let isFileValid = false;
  let isFileDirty = false;
  let fileError = "";
  let isPageLoading = true;

  let allowedFileTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/tiff",
    "application/pdf"
  ];
  let types =[];
  let types_v2 =[];
  let isDeleting = false;
  let helpText='';
  let showMoreInfoHelptext = false;

  let isUploadVisible =false;
  let isUploadVisible_v2 =false;
  let isUploadRemoveVisible = false;

  const getDocuments = () => {
    return wrappedFetch(`/documents?applicationId=${applicationId}&x=${new Date().getTime()}`)
      .then(response => response.json())
      .then(response => (documents = response));
  };

  const getDocumentTypes = () => {
    return wrappedFetch(
      `/documents/GetDocumentTypesList?applicationId=${applicationId}&childId=${id}`
    ).then(response => response.json());   
  };

  async function loadDocumentTypes() {
    var response = await getDocumentTypes();
    types= response.documentTypeList;
    types_v2= groupData(response.documentTypeList_v2);
    isUploadVisible_v2 = Array.isArray(types_v2) && types_v2.length > 0;
    helpText = response.helpText;
}

  const deleteDocument = () => {
    isDeleting = true;
    wrappedFetch(`/documents/deletefile?docId=${fileToDelete.id}`, {
      method: "post"
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          documents = documents.filter(d => d.id != fileToDelete.id);
          fileToDelete = null;
          
          modalMessage = "Document deleted successfully.";
          dispatch("notification", modalMessage)

          loadDocumentTypes();
        }
        isDeleting = false;
      });
  };

  const validate = e => {
    docTypeError = "";
    fileError = "";
    isDocTypeValid = true;
    isFileValid = true;
    if (isDocTypeDirty && !docType.id) {
      isDocTypeValid = false;
      docTypeError = "You must choose a document type.";
    }
    if (isFileDirty && !document) {
      isFileValid = false;
      fileError = "You must browse for a document to attach.";
    } else if (isFileDirty && document && document.length > 0) {
      if (!allowedFileTypes.includes(document[0].type)) {
        isFileValid = false;
        fileError = "Only images or PDFs are accepted.<br/>";
      }
       if((document[0].size/(1024*1024)).toFixed(2) > 30) //converting bytes to MB
      {       
        isFileValid = false;
        fileError = fileError+"Document size is too big.";

      }
    }
    return isDocTypeValid && isFileValid;
  };

  const validate_v2 = e => {
    docTypeError = "";
    fileError = "";
    isDocTypeValid = true;
    isFileValid = true;
    if (isFileDirty && !document) {
      isFileValid = false;
      fileError = "You must browse for a document to attach.";
    } else if (isFileDirty && document && document.length > 0) {
      if (!allowedFileTypes.includes(document[0].type)) {
        isFileValid = false;
        fileError = "Only images or PDFs are accepted.<br/>";
      }
       if((document[0].size/(1024*1024)).toFixed(2) > 30) //converting bytes to MB
      {       
        isFileValid = false;
        fileError = fileError+"Document size is too big.";

      }
    }
    return isDocTypeValid && isFileValid;
  };






  const onAttachSubmit_v2 = e => {
    e.preventDefault();
    isFileDirty = true;
    isDocTypeDirty = true;
    uploadError = "";
    let formData = new FormData(e.target);
    if (!validate_v2()) return false;
    uploadingDocument = true;
    wrappedFetch("/documents/uploadfile_v2", {
      method: "post",
      body: formData
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          showAddFile_v2 = false;
          isUploadRemoveVisible = true;
          loadDocumentTypes();  
          modalMessage = "Document attached successfully.";
          dispatch("notification", modalMessage)
        } else {
          uploadError = response.message;
        }
        uploadingDocument = false;
      });
  };



  const onAttachSubmit = e => {
    e.preventDefault();
    isFileDirty = true;
    isDocTypeDirty = true;
    uploadError = "";
    let formData = new FormData(e.target);
    if (!validate()) return false;
    uploadingDocument = true;
    wrappedFetch("/documents/uploadfile", {
      method: "post",
      body: formData
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          showAddFile = false;
          isUploadRemoveVisible = true;
          getDocuments();          
          modalMessage = "Document attached successfully.";
          dispatch("notification", modalMessage)
        } else {
          uploadError = response.message;
        }

        uploadingDocument = false;
      });
  };

  const getChild = async () => {
  let result = await wrappedFetch(`/child/getchildren?childId=${id}&x=${new Date().getTime()}`).then(
      response => response.json()
    );

    let applications =result.children;
     
      let app = applications[0].applications.filter(a=> a.applicationId == applicationId)[0];

      isUploadVisible= app.isUploadVisible;
      isUploadRemoveVisible = app.isUploadRemoveVisible;
        
  };

  
  const getContent = async () => {
    const getHelpContents = await wrappedFetch("helpcontent?helpId=documentupload");
    return await getHelpContents.json();
  };

  onMount(async()=>{
    loadDocumentTypes();
    await getChild();
  await getDocuments();

    let contents = await getContent();
    contents.find(c => { if(c.type=='p')  documentText = c.text; });;
  isPageLoading = false;
  })

  function groupData(data) {
    const groupedMap = data.reduce((acc, item) => {
      const key = `${item.parent_id}|${item.parent_Name}|${item.parent_Description}|${item.lA_Description}`;
      if (!acc[key]) {
        acc[key] = {
          parent_id: item.parent_id,
          parent_Name: item.parent_Name,
          Parent_Description: item.parent_Description,
          LA_Description: item.lA_Description,
          Children: []
        };
      }
      acc[key].Children.push({
        child_Id: item.child_Id,
        child_Name: item.child_Name,
        Section: item.section,
        Documents: item.documents
      });
      return acc;
    }, {});
    return Object.values(groupedMap);
  }
 
  const handleDocumentTypesChange = () => {};
  export const saveAndExit = async () => {
    dispatch("pageChange", "/user/home");
  };
  let browser = utils.getBrowserName();

  function linkify(text) {
  const urlPattern = /https?:\/\/[^\s"']+/gi;
  return text.replace(urlPattern, url => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
}
</script>

<style>
  table td:not([align]),
  table th:not([align]) {
    vertical-align: top;}
    .document-list{
      font-size: 1.25rem;;
    }
  .doc-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    min-height: 3.25rem;
    box-sizing: border-box;
  }
  .doc-row + .doc-row {
    border-top: 1px solid #eee;
  }
  /* The text block (filename + timestamp) stacks vertically inside the row */
  .doc-row > div:first-child {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
  }
  /* Stop the button being stretched by the flex container */
  .doc-row .button {
    flex: 0 0 auto;
  }
  /* + button sits in its own column, aligned with the first .doc-row */
  .add-btn-wrap {
    display: flex;
    align-items: center;
    min-height: 3.25rem;
    padding: 0.35rem 0;
    box-sizing: border-box;
  }
  .add-btn-wrap .button {
    flex: 0 0 auto;
  }
</style>

<svelte:head>
  <title>Documents | eAdmissions</title>
</svelte:head>
{#if isPageLoading}
<Spinner/>
{:else}

<div class="field">
  <a href="/user/home">
    <span class="fas fa-arrow-left" />
    Back
  </a>
</div>
  
  <div style="display:inline-flex" >
    <h1 class="title is-3">Attach documents for {$Child.forename + ' ' + $Child.surname}</h1>
    <span name="infoIcon" class="icon helpicon"  on:click={() => {showHelpModal = true;}}>
      <span class="fas fa-info-circle"></span>
    </span>
  </div>
  <p class="subtitle is-5">{@html documentText}</p>
  


{#each types_v2 as parent}
  <div class="parent">

    <strong>{parent.parent_Name}</strong><br>
    
    {#if parent.LA_Description}
      <em>{@html linkify(parent.LA_Description)}</em><br>
    {:else if parent.Parent_Description}
      <em>{@html linkify(parent.Parent_Description)}</em><br>
    {/if}
<br>
     {#if parent.parent_id !== 0}
        <table class="table" tabindex="0" aria-label="documents you have uploaded" width="100%">
          <thead>
            <tr style="background-color: #f2f2f2;">
              <th style="border-bottom: 1px solid #55aab0 !important;">Document</th>
              <th style="border-bottom: 1px solid #55aab0 !important;" width="30%">File Name</th>
              <th style="border-bottom: 1px solid #55aab0 !important;" width="5%" />
            </tr>
          </thead>
          <tbody>
            {#if parent.Children.filter(c => c.Section === 'B').length > 0}
          <tr style="background-color: #fafafa;">
            <th colspan="3"><strong>Section A</strong></th>
          </tr>
          {/if}
        {#each parent.Children.filter(c => c.Section === 'A' || c.Section == null || c.Section === '') as child}
            <tr>
              <td>{child.child_Name}</td>
              <td>
                {#if child.Documents && child.Documents.length > 0}
                  {#each child.Documents as doc}
                    <div class="doc-row">
                      <div>
                        <a
                          href="#"
                          on:click|preventDefault={() => {docPreview = doc.id; docName = doc.fileName}}
                          title="View document">
                          {doc.fileName}
                        </a>
                        <small>{doc.uploadedStr}</small>
                      </div>
                      <div>
                        <button
                          on:click={() => (fileToDelete = doc)}
                          class="button is-danger" style="font-size:0.9rem;">
                          <span class="fa fa-trash" />
                        </button>
                      </div>
                    </div>
                  {/each}
                {:else}
                  &nbsp;
                {/if}
              </td>
              <td>
                {#if isUploadVisible}
                  <div class="add-btn-wrap">
                    <button
                      on:click={() => {showAddFile_v2 = true; documentTypeID=child.child_Id, documentTypeName=child.child_Name, documentTypeParentName=parent.parent_Name }}
                      class="button is-primary" style="font-size:0.9rem;"
                      title="Add another file">
                      <span class="fa fa-plus" />
                    </button>
                  </div>
                {/if}
              </td>
            </tr>
            {/each} 
        
            {#if parent.Children.filter(c => c.Section === 'B').length > 0}
          <tr style="background-color: #fafafa;">
            <th colspan="3"><strong>Section B</strong></th>
          </tr>    
{/if}
        {#each parent.Children.filter(c => c.Section === 'B') as child}
        <tr>
          <td>{child.child_Name}</td>
          <td>
            {#if child.Documents && child.Documents.length > 0}
              {#each child.Documents as doc}
                <div class="doc-row">
                  <div>
                    <a
                      href="#"
                      on:click|preventDefault={() => {docPreview = doc.id; docName = doc.fileName}}
                      title="View document">
                      {doc.fileName}
                    </a>
                    <small>{doc.uploadedStr}</small>
                  </div>
                  <div>
                    {#if isUploadRemoveVisible}
                      <button
                        on:click={() => (fileToDelete = doc)}
                        class="button is-danger" style="font-size:0.9rem;">
                        <span class="fa fa-trash" />
                      </button>
                    {/if}
                  </div>
                </div>
              {/each}
            {:else}
              &nbsp;
            {/if}
          </td>
          <td>
            {#if isUploadVisible}
              <div class="add-btn-wrap">
                <button
                  on:click={() => {showAddFile_v2 = true; documentTypeID=child.child_Id, documentTypeName=child.child_Name, documentTypeParentName=parent.parent_Name }}
                  class="button is-primary" style="font-size:0.9rem;"
                  title="Add another file">
                  <span class="fa fa-plus" />
                </button>
              </div>
            {/if}
          </td>
        </tr>
        {/each}   
            

          </tbody>
        </table>
{/if}
  </div>
{/each}

<style>
  .parent {
    margin: 1rem 0;
    padding: 1.5rem;
    border: 1px solid #55aab0;
    border-radius: 0.5rem;
  }
  .child {
    margin: 0.3rem 0;
  }

</style>


<ul>
  {#each types as type}
  <li class="document-list">{type.name}</li>
  {/each}
</ul>





<p class="subtitle is-5">
Additional information from your local authority is available. Please <a href="#" on:click|preventDefault={()=>showMoreInfoHelptext=true}>click here</a>.
</p>
<p class="subtitle is-5">
For further information please contact your home local authority. Their details can be found on the <a href="/contact">Local Authority Details</a> page.
</p>

{#if documents.length > 0}
<div class="table-container">
  
  <table class="table" tabindex="0" aria-label="documents you have uploaded">
    <thead>
      <tr>
      <th />
       <th>File Name</th>
       <th>Document Type</th>
        <th>Reference</th>
        <th>Uploaded</th>
      </tr>
    </thead>
    <tbody>
      {#each documents as doc}
        <tr>
         <td>
           {#if isUploadRemoveVisible}
            <button
              on:click={() => (fileToDelete = doc)}
              class="button is-danger" style="font-size:0.9rem;">
              <span class="fa fa-trash" />
              <span style="margin-left:6px">Delete</span>
            </button>
            {/if}
          </td>
            <td>
            <a
              href="#"
              on:click|preventDefault={() => {docPreview = doc.id; docName = doc.fileName}}
              title="View document">
              {doc.fileName}
            </a>
          </td>
           <td>{doc.name}</td>
          <td>{doc.applicationRef} - {doc.id}</td>
          <td>{doc.uploadedStr}</td>
         
        
         
        </tr>
      {/each}
    </tbody>
  </table>
</div>
{/if}
<div style="text-align: right;">
  
  {#if isUploadVisible && !isUploadVisible_v2}
  <button
    class="button is-primary"
    on:click={() => {
      showAddFile = true;
      docType = {};
    }}>
    Attach
  </button>
  {/if}
  <a href="/user/home" class="button" style="margin-right: 15px;">
    Home
  </a>
</div>
{/if}

<Modal bind:showModal={docPreview}>
  <div style="text-align: center;">
  {#if docName.split('.')[1] == 'pdf'}
    {#if browser == 'ie'}
      {#if !utils.isAcrobatInstalled()}
        <p>To preview file, please download Adobe PDF Reader from <a href="https://get.adobe.com/uk/reader/" target='_blank'>here</a></p>
      {:else}
        <iframe src="/documents/preview?docId={docPreview}" title="{docName}" style="width: 100%; height: calc(50vh);"/>
      {/if}
    {:else}
      <iframe src="/documents/preview?docId={docPreview}" title="{docName}" style="width: 100%; height: calc(50vh);"/>
    {/if}
  {:else}
    <img src="/documents/preview?docId={docPreview}" alt="attached image"/>
  {/if}
  </div>
  <br />
  <footer class="modal-card-foot buttons is-right" slot="footer">
  <div style="text-align: right;">
    <a href="/documents/preview?docId={docPreview}" download={docName} target="_blank" class="button is-primary">
      Download
    </a>
  </div>
  </footer>
</Modal>

<Modal bind:showModal={showAddFile}>
  <form on:submit={onAttachSubmit}>
    <input type="hidden" name="applicationId" value={applicationId} />
    <input type="hidden" name="docType" value={docType.id} />
    <input type="hidden" name="schoolId" value={docType.schoolId} />
    <div class="field">

      <label class="label" for="type">Document type</label>

      <div
        class="select {!isDocTypeValid && isDocTypeDirty ? 'is-danger' : ''}">

        <select
          name=""
          id="type"
          bind:value={docType}
          on:change={() => {
            isDocTypeDirty = true;
            validate();
          }}>
          <!-- {#await getDocumentTypes()}
            <option value="0">Loading options</option>
          {:then types}
            <option value="0">Select an option</option>
            {#each types as t}
              <option value={t}>{t.name}</option>
            {/each}
          {/await} -->
          <option value="0">Select an option</option>
          {#each types as t}
            <option value={t}>{t.name}</option>
          {/each}
        </select>
      </div>
      {#if docTypeError != ''}
        <span>
          <p class="help has-text-danger" style="margin-top:.5rem">
            {docTypeError}
          </p>
        </span>
      {/if}
    </div>

    <div class="field">
      <label class="label" for="upload">Browse for document to attach</label>

      <div class="control">
        <input
          class="input {!isFileValid && isFileDirty ? 'is-danger' : ''}"
          type="file"
          name="document"
          bind:files={document}
          id="upload"
          on:change={() => {
            isFileDirty = true;
            validate();
          }} />
        {#if fileError != ''}
          <span>
            <p class="help has-text-danger">{@html fileError}</p>
          </span>
        {/if}
      </div>
    </div>
    {#if uploadError != ''}
      <div class="field">
        <p class="help is-danger">
          {@html uploadError}
        </p>
      </div>
    {/if}

    <!-- <input
          type="submit"
          class="button is-primary {uploadingDocument ? 'is-loading' : ''}"
          name="continue"
          id="continue"
          value="Attach"
          disabled={uploadingDocument} />       -->
    <button
      type="submit"
      class="button is-primary {uploadingDocument ? 'is-loading' : ''}"
      name="continue"
      id="continue"
      value="Attach"
      disabled={uploadingDocument}>
      Attach
    </button>

    <div style="text-align: justify; font-size:1rem; margin-top: 10px;">
      <strong>Please Note:</strong>
      <p>
        Supplementary Information Forms (SIFs) must be sent directly to the
        school. Please check the relevant <a href="/contact/" target="_blank">Local Authority's guidance.</a>
      </p>
      <p style=" margin-top: 10px;">
        If you are unable to attach any documents please send them to your Home
        Local Authority quoting your child's name and application reference
        number.
      </p>
    </div>
  </form>
</Modal>

<Modal bind:showModal={showAddFile_v2}>
  <form on:submit={onAttachSubmit_v2}>
    <input type="hidden" name="applicationId" value={applicationId} />
    <input type="hidden" name="documentId" value={documentTypeID} />
    <input type="hidden" name="docType" value={documentTypeID} />

    <label class="label" for="type">Document Category:</label>{documentTypeParentName}<br><br>
    <label class="label" for="name">Document:</label>{documentTypeName}<br><br>

    {#if docTypeError != ''}
        <span>
          <p class="help has-text-danger" style="margin-top:.5rem">
            {docTypeError}
          </p>
        </span>
      {/if}
    
    
      <div class="field">
        <label class="label" for="upload">Browse for document to attach</label>
  
        <div class="control">
          <input
            class="input {!isFileValid && isFileDirty ? 'is-danger' : ''}"
            type="file"
            name="document"
            bind:files={document}
            id="upload_v2"
            on:change={() => {
              isFileDirty = true;
              validate_v2();
            }} />
          {#if fileError != ''}
            <span>
              <p class="help has-text-danger">{@html fileError}</p>
            </span>
          {/if}
        </div>
      </div>
      {#if uploadError != ''}
        <div class="field">
          <p class="help is-danger">
            {@html uploadError}
          </p>
        </div>
      {/if}
      <button
      type="submit"
      class="button is-primary {uploadingDocument ? 'is-loading' : ''}"
      name="continue"
      id="continue"
      value="Attach"
      disabled={uploadingDocument}>
      Attach
    </button>

  <div style="text-align: justify; font-size:1rem; margin-top: 10px;">
    <strong>Please Note:</strong>
    <p>
      Supplementary Information Forms (SIFs) must be sent directly to the
      school. Please check the relevant <a href="/contact/" target="_blank">Local Authority's guidance.</a>
    </p>
    <p style=" margin-top: 10px;">
      If you are unable to attach any documents please send them to your Home
      Local Authority quoting your child's name and application reference
      number.
    </p>
  </div>
 </form>
</Modal>

<ModalConfirm showModal={fileToDelete} on:ok={deleteDocument} bind:isUpdating={isDeleting}>
  Are you sure you want this delete this file?
</ModalConfirm>

{#if showHelpModal}
  <Modal bind:showModal={showHelpModal}>
    <Help
      {helpId}
      showSearchOption={false}
      showContent={false}
      doAnimation={false}
      isPopup={true} />
    <!-- <footer class="modal-card-foot buttons is-right" slot="footer">
      <button
        class="button continue"
        on:click={() => {
          showHelpModal = false;
        }}>
        Close
      </button>

    </footer> -->
  </Modal>
{/if}

<Modal bind:showModal={showMoreInfoHelptext}>
{@html helpText}

</Modal>